// extracted by mini-css-extract-plugin
export default {"container":"AssignmentViewer_container__BE6+f","center-col":"AssignmentViewer_center-col__f7tif","fabRoot":"AssignmentViewer_fabRoot__8T0FP"};